import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Testimonials from "./Testimonials";
import FAQ from "./FAQ";
import { Helmet } from "react-helmet-async";

export default function About() {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  const primaryColor = "#684df4";

  return (
    <>
      <Helmet>
        <title>About Technic Mentors - Best Software & IT Services Company</title>
        <link rel="canonical" href="https://technicmentors.com/about" />
      </Helmet>

      <div>
        {/* Hero Header */}
        <div className="allHeaderBg">
          <div className="allHeader-overlay d-flex align-items-center justify-content-center">
            <div>
              <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
                About Technic Mentors
              </h1>
            </div>
          </div>
        </div>

        {/* Introduction Section */}
        <div className="container mt-5" data-aos="fade-up" data-aos-duration="1000">
          <div className="section-title text-center mb-5">
            <h2>About Us</h2>
            <h3>
              Your Trusted Partner in <span>Digital Excellence</span>
            </h3>
            <p className="lead" style={{ maxWidth: "900px", margin: "0 auto" }}>
              We craft innovative, reliable, and future-ready software solutions that empower businesses to grow, scale, and succeed in a fast-changing world.
            </p>
          </div>

          <div className="row align-items-center g-5">
            <div className="col-lg-6" data-aos="fade-right" data-aos-duration="1200">
              <img
                src="assets/img/tech1.png"
                alt="Technic Mentors Team"
                className="img-fluid "
                style={{ borderRadius: "16px" }}
              />
            </div>

            <div className="col-lg-6" data-aos="fade-left" data-aos-duration="1200">
              <h3 className="mb-4" style={{ fontSize: "2.1rem", fontWeight: 700 }}>
                Committed to Delivering Excellence
              </h3>
              <p style={{ textAlign: "justify", lineHeight: 1.8 }}>
                Technic Mentors is a forward-thinking software company specializing in custom development, IT consulting, and digital transformation. We combine deep technical expertise with a passion for solving real business problems — delivering high-quality, scalable solutions that drive measurable results.
              </p>
              <p style={{ textAlign: "justify", lineHeight: 1.8 }}>
                From startups to enterprises, educational institutions to government bodies — we build software that matters. Our team believes in clean code, modern architecture, strong security, and long-term partnerships.
              </p>
              <p className="fw-medium mt-4" style={{ color: primaryColor, fontSize: "1.15rem" }}>
                Your success is our success.
              </p>
            </div>
          </div>
        </div>

        {/* Mission & Vision Cards */}
        <div className="container my-5 py-5" data-aos="fade-up" data-aos-duration="1000">
          <div className="row g-4 justify-content-center">
            {[
              {
                icon: "fa-bullseye",
                title: "Our Mission",
                text: "To revolutionize the software landscape through innovation, quality craftsmanship, and genuine mentorship — empowering businesses and individuals to thrive in the digital era.",
              },
              {
                icon: "fa-binoculars",
                title: "Our Vision",
                text: "To create a world where cutting-edge technology meets expert guidance, building an ecosystem of continuous innovation, sustainable growth, and limitless possibilities.",
              },
            ].map((item, i) => (
              <div className="col-lg-5 col-md-6" key={i}>
                <div
                  className="card shadow-sm h-100 text-center p-4"
                  style={{
                    transition: "all 0.28s ease",
                    borderRadius: "16px",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#ffffff",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = primaryColor;
                    e.currentTarget.style.color = "#ffffff";
                    e.currentTarget.style.transform = "translateY(-12px) scale(1.04)";
                    e.currentTarget.style.boxShadow = "0 25px 60px rgba(0,0,0,0.18)";
                    e.currentTarget.style.borderColor = primaryColor;
                    const icon = e.currentTarget.querySelector("i");
                    if (icon) icon.style.color = "#ffffff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "white";
                    e.currentTarget.style.color = "inherit";
                    e.currentTarget.style.transform = "translateY(0) scale(1)";
                    e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.08)";
                    e.currentTarget.style.borderColor = "#e0e0e0";
                    const icon = e.currentTarget.querySelector("i");
                    if (icon) icon.style.color = primaryColor;
                  }}
                >
                  <i
                    className={`fa-solid ${item.icon} fa-4x mb-4`}
                    style={{ color: primaryColor, transition: "color 0.28s ease" }}
                  ></i>
                  <h4 className="mb-3" style={{ fontWeight: 700 }}>
                    {item.title}
                  </h4>
                  <p className="mb-0" style={{ lineHeight: 1.7 }}>
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Stats / Milestones */}
        <div
          className="container-fluid py-5"
          style={{
            background: `linear-gradient(135deg, ${primaryColor}22 0%, #f8f9fa 100%)`,
          }}
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <div className="container">
            <div className="row text-center g-4">
              {[
                { icon: "fa-calendar-check", number: "2016", label: "Year of Establishment" },
                { icon: "fa-handshake-angle", number: "550+", label: "Happy Clients Worldwide" },
                { icon: "fa-users", number: "20+", label: "Active Long-term Partners" },
                { icon: "fa-briefcase", number: "500+", label: "Projects Delivered" },
              ].map((stat, i) => (
                <div className="col-lg-3 col-md-6" key={i}>
                  <div
                    className="p-4 rounded-3 shadow-sm"
                    style={{
                      background: "white",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-10px)";
                      e.currentTarget.style.boxShadow = "0 15px 40px rgba(104,77,244,0.18)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.08)";
                    }}
                  >
                    <i
                      className={`fa-solid ${stat.icon} fa-3x mb-3`}
                      style={{ color: primaryColor }}
                    ></i>
                    <h2 style={{ fontWeight: 800, color: primaryColor }}>{stat.number}</h2>
                    <p className="mb-0 fw-medium">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <Testimonials />
        <FAQ />
      </div>
    </>
  );
}